import React from 'react'
import { Link } from 'react-router-dom'
import SEO from './SEO'
import './../styles/About.css'

const About = () => (
  <>
    <SEO
      path="/about"
      title="About QA Tech"
      description="QA Tech is a UK-based software quality, engineering and marketing consultancy. Engineers first — helping ambitious businesses build, test and grow with confidence."
      keywords="about QA Tech, software consultancy UK, software testing company, QA consultancy, UK engineering team, software quality experts"
      jsonLd={{
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: 'About QA Tech',
        url: 'https://qatechltd.com/about',
        about: {
          '@type': 'Organization',
          name: 'QA Tech',
          url: 'https://qatechltd.com',
        },
      }}
    />
    <div className="body about-page">
      <header className="about-hero">
        <span className="eyebrow">About</span>
        <h1>Engineers first.</h1>
        <p>
          QA Tech is a UK-based software quality, engineering and marketing
          consultancy. We were founded by quality engineers who got tired of
          watching projects ship late, break in production, and disappoint
          customers. We help ambitious businesses build, test and grow with
          confidence.
        </p>
      </header>

      <section className="about-section">
        <h2>What we believe</h2>
        <p>
          Software is only as good as the confidence people have in it. That
          confidence comes from craft &mdash; from clean code, honest testing,
          accessible interfaces and reliable operations. Everything we do flows
          from that.
        </p>
      </section>

      <section className="about-section">
        <h2>What we do</h2>
        <p>
          We design and build modern web and mobile applications, run
          end-to-end software testing programmes, and handle the marketing
          foundations that turn a great product into a growing business
          &mdash; including SEO, Google Analytics, Google Ads and full
          company rebrands.
        </p>
        <p>
          Read more on <Link to="/services">our services page</Link> or our{' '}
          <Link to="/marketing">marketing services page</Link>.
        </p>
      </section>

      <section className="about-section">
        <h2>How we work</h2>
        <p>
          Small teams. Senior engineers. Plain English. We over-communicate,
          we ship in small steps, and we measure what we change. No theatre,
          no jargon, no surprise invoices.
        </p>
      </section>

      <section className="about-section about-cta">
        <h2>Talk to us</h2>
        <p>
          We&rsquo;d love to hear what you&rsquo;re working on.{' '}
          <Link to="/contact">Get in touch</Link>.
        </p>
      </section>
    </div>
  </>
)

export default About
